<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_edit_two_phase_method'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="170px" class="dialog-form-item">
                        <!-- ##################################### -->
                        <!-- Method type                           -->
                        <!-- ##################################### -->
                        <el-form-item prop="methodType" ref="methodType">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_two_phase_method_type'"/>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_two_phase_method_type')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-two-phase-method-item" v-model="twoPhaseMethod.methodType" style="margin-left=15px" @change="handleOptionChange()">
                                <el-option v-for="methodType in methodTypeList" :key="methodType.type" :label="methodType.displayName" :value="methodType.type"></el-option>
                            </el-select>
                        </el-form-item>
                        <div v-if="methodTypeList[twoPhaseMethod.methodType].targetTypeName != null">
                            <!-- ##################################### -->
                            <!-- Method target                         -->
                            <!-- ##################################### -->
                            <el-form-item prop="methodTarget" ref="methodTarget">
                                <div slot="label" style="text-align:left">
                                    <span>{{methodTypeList[twoPhaseMethod.methodType].targetTypeName}}</span>
                                </div>
                                <el-select class="select-two-phase-method-item" v-model="twoPhaseMethod.target" style="margin-left=15px" @change="handleOptionChange()">
                                    <el-option v-for="methodTarget in methodTargetList" :key="methodTarget.type" :label="methodTarget.displayName" :value="methodTarget.type"></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- ##################################### -->
                            <!-- Direct input                          -->
                            <!-- ##################################### -->
                            <el-form-item v-if="methodTargetList[twoPhaseMethod.target].directInput" prop="directInput" ref="directInput">
                                <el-input id="directInput" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="directInput"
                                     @input.native="inputCheck($event.target.id)" clearable @clear="inputCheck($event.target.id)"/>
                            </el-form-item>
                        </div>
                        <!-- ##################################### -->
                        <!-- Sub node                              -->
                        <!-- ##################################### -->
                        <el-form-item v-if="subNodeButtonVisible" prop="processSubNode" ref="processSubNode">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_process_sub_node'"/>
                            </div>
                            <el-switch v-model="processSubNode" active-color="#5171cb" :disabled="disableProcessSubNode"></el-switch>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    data() {
        return {
            twoPhaseMethod: {
                methodType: 0,
                target: 0,
            },
            methodTypeList: null,
            methodTargetList: [],
            directInput: null,
            disableButton: false,
            invalidDirectInput: true,
            isComposing: false,
            processSubNode: false,
            disableProcessSubNode: false,
            subNodeButtonVisible: false,
            targetType: constants.OBJECT_USER,
            targetId: 0,
        };
    },
    methods: {
        saveChange: function() {

            let setTwoPhaseMethodRequest = {
                targetId: this.targetId,
            };

            let selectedType = this.methodTypeList[this.twoPhaseMethod.methodType];
            // no target case
            if (selectedType.targetTypeName == null) {
                setTwoPhaseMethodRequest['methodType'] = selectedType.requestType;
                this.finalizeAndDoRequest(setTwoPhaseMethodRequest, selectedType.displayName);
                return;
            }

            let selectedTarget = this.methodTargetList[this.twoPhaseMethod.target];
            let methodType = selectedTarget.requestType;
            if (typeof methodType != 'number') {
                methodType = selectedType.requestType[methodType];
            }
            setTwoPhaseMethodRequest['methodType'] = methodType;

            if (selectedTarget.directInput) {
                let prefix = selectedType.prefixForDirectInput;
                // TODO: +81 conversion should be updated to handle other countries
                let directInput = this.directInput;
                if (selectedType.displayName == "SMS") {
                    directInput = '+81' + directInput.substr(1, directInput.length - 1);
                }
                setTwoPhaseMethodRequest['method'] = prefix + directInput;
            }

            if ('adminUserName' in selectedTarget) {
                setTwoPhaseMethodRequest['otherUserName'] = selectedTarget.adminUserName;
            }

            this.finalizeAndDoRequest(setTwoPhaseMethodRequest, selectedType.displayName);
        },
        finalizeAndDoRequest(setTwoPhaseMethodRequest, methodDisplayName) {
            if (this.targetType == constants.OBJECT_NODE) {
                setTwoPhaseMethodRequest['processSubNode'] = this.processSubNode;
            }
            this.$emit('save', setTwoPhaseMethodRequest, methodDisplayName);
        },
        handleOptionChange: function() {
            // case of cancel
            if (this.methodTypeList[this.twoPhaseMethod.methodType].targetTypeName == null) {
                this.disableButton = false;
                return;
            }

            if (this.methodTargetList[this.twoPhaseMethod.target].directInput) {
                this.inputValidate();
                this.disableButton = this.invalidDirectInput;
            } else {
                this.disableButton = false;
            }
        },
        inputCheck(eventTargetId) {
            let validateResult = this.inputValidate();
            this.disableButton = this.invalidDirectInput;
            if (validateResult.valid) {
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
        },
        inputValidate() {
            let validationRule = this.methodTypeList[this.twoPhaseMethod.methodType].validationRule;
            let validateResult = commonValidate.validateItem(this.$i18n, validationRule, this.directInput, this.appData.countryCodeAlpha3);
            this.invalidDirectInput = !(validateResult.valid);
            return validateResult;
        },
        getMessageText(messageId) {
            return commonUtil.getMessageText(this.$i18n, messageId);
        },
    },
    created: function() {
        this.methodTypeList = [
            {type: 0, displayName: "Email", targetTypeName: this.getMessageText("item_tenant_email"), validationRule: "emailAddress", prefixForDirectInput: "EMAIL:",
            requestType: {
                user: 2,
                admin: 5,
            }},
        ];
        let index = 1;
        if (this.appData.smsTwoPhaseMethod) {
            this.methodTypeList.push({
                type: index, displayName: "SMS", targetTypeName: this.getMessageText("item_tenant_phone"), validationRule: "mobilePhoneNumber", prefixForDirectInput: "SMS:",
                requestType: {
                    user: 3,
                    admin: 6,
                },
            });
            index++;
        }
        this.methodTypeList.push({
            type: index, displayName: this.getMessageText("info_two_phase_method_show_console"), targetTypeName: null, validationRule: null, prefixForDirectInput: null,
            requestType: 4,
        });
        index++;
        this.methodTypeList.push({
            type: index, displayName: this.getMessageText("info_two_phase_method_cancel"), targetTypeName: null, validationRule: null, prefixForDirectInput: null,
            requestType: 0,
        });

        if (this.nodeInfo != null) {
            // #####################################
            // Target is NODE
            // #####################################
            this.targetType = constants.OBJECT_NODE;
            this.targetId = this.nodeInfo.id;
            this.subNodeButtonVisible = true;
            if (this.nodeInfo.hasChild == 0) {
                this.disableProcessSubNode = true;
            }

            this.methodTargetList.push({type: 0, displayName: this.getMessageText("item_two_phase_method_user_info"), directInput: false, requestType: 'user'});
            let index = 1;
            for (let aclRwUser of this.aclRwUsers) {
                let shownName = aclRwUser.userName + ' / ' + aclRwUser.displayName;
                this.methodTargetList.push({type: index, displayName: this.getMessageText("item_two_phase_method_info").replace("{target}", shownName), directInput: false, requestType: 'admin', adminUserName: aclRwUser.userName});
                index++;
            }
            this.methodTargetList.push({type: index, displayName: this.getMessageText("item_two_phase_method_direct_input"), directInput: true, requestType: 1});
        } else {
            // #####################################
            // Target is USER
            // #####################################
            this.targetType = constants.OBJECT_USER;
            this.targetId = this.userAttribute.id;
            let shownName = this.userAttribute.name + ' / ' + this.userAttribute.displayName;
            this.methodTargetList.push({type: 0, displayName: this.getMessageText("item_two_phase_method_info").replace("{target}", shownName), directInput: false, requestType: 'user'});
            this.methodTargetList.push({type: 1, displayName: this.getMessageText("item_two_phase_method_direct_input"), directInput: true, requestType: 1});
        }
    },
    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    },
    watch: {
    },
    props: ['appData', 'userAttribute', 'nodeInfo', 'aclRwUsers' ]
}
</script scoped>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}
.el-select.select-two-phase-method-item {
    width: 350px;
}
.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

</style>
